import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { MessageService } from '@lib/messages/message.service';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { StoreThreadIdsActionRequest, ThreadIds, ThreadIdsSingleResponse } from '@lib/api/models/message';

@Component({
    selector: 'app-unread-messages-dialog',
    imports: [ComponentsModule, ErrorPanelComponent],
    templateUrl: './unread-messages-dialog.component.html',
    standalone: true,
    styleUrl: './unread-messages-dialog.component.scss'
})
export class UnReadMessagesDialogComponent {
    protected readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly _messagesService = inject(MessageService);
    private readonly _snackBar = inject(SnackBarService);
    protected readonly messages = inject<ThreadIds>(DIALOG_DATA);

    unReadMessagesRequest = new SendableRequest<ThreadIdsSingleResponse, StoreThreadIdsActionRequest>({
        request: () => this._messagesService.unReadThreads(this.messages.ids),
        onSuccess: () => {
            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Messages un-read successfully',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
            this.dialogRef.close(true);

        },
        onError: () => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Messages failed to un-read',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
        }
    });

    unRead() {
        this.unReadMessagesRequest.send({ threadIds: this.messages.ids });
    }


    public static show(dialog: DialogService, data: ThreadIds) {
        return dialog.openDialog<DialogRef, ThreadIds>(UnReadMessagesDialogComponent, {
                data
            }
        );
    }

}
